import { render } from "./SsoTabs.vue?vue&type=template&id=48693472"
import script from "./SsoTabs.vue?vue&type=script&lang=js"
export * from "./SsoTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__